export interface ReleaseNotesGroup {
  /** "Added", "Fixed", or "Changed". Empty for notes under no heading. */
  heading: string;
  items: string[];
}

export interface ReleaseNotes {
  /** "0.1.0", or null for changes not released yet. */
  version: string | null;
  date: string | null;
  groups: ReleaseNotesGroup[];
}

const RELEASE_LINE = /^## \[([^\]]+)\](?: - (\S+))?\s*$/;

/** Reads CHANGELOG.md. Newest first, leaving out an empty Unreleased section. */
export function parseReleaseNotes(changelog: string): ReleaseNotes[] {
  const releases: ReleaseNotes[] = [];
  let current: ReleaseNotes | undefined;
  let group: ReleaseNotesGroup | undefined;
  for (const line of changelog.split("\n")) {
    const release = RELEASE_LINE.exec(line);
    if (release !== null) {
      const name = release[1] ?? "";
      current = {
        version: name.toLowerCase() === "unreleased" ? null : name,
        date: release[2] ?? null,
        groups: [],
      };
      group = undefined;
      releases.push(current);
    } else if (current !== undefined && line.startsWith("### ")) {
      group = { heading: line.slice(4).trim(), items: [] };
      current.groups.push(group);
    } else if (current !== undefined && line.startsWith("- ")) {
      if (group === undefined) {
        group = { heading: "", items: [] };
        current.groups.push(group);
      }
      group.items.push(line.slice(2).trim());
    }
  }
  return releases.filter((item) => item.version !== null || item.groups.length > 0);
}
